"use client";

import { c as _c } from "react/compiler-runtime";
import { Select, SelectItem } from "@dc/ui/components";
import { useTranslations } from "next-intl";
import type { FC } from "react";
interface TeamSwitcherSelectProps {
  teams: Array<{
    id: string;
    name: string;
  }>;
  selectedTeamId?: string | null;
  isLoading?: boolean;
  isUpdating?: boolean;
  hasSingleTeam?: boolean;
  onSelectionChange: (teamId: string) => void;
}
export const TeamSwitcherSelect: FC<TeamSwitcherSelectProps> = t0 => {
  const $ = _c(32);
  const {
    teams,
    selectedTeamId,
    isLoading,
    isUpdating,
    hasSingleTeam,
    onSelectionChange
  } = t0;
  const t = useTranslations("navigation.team_switcher");
  const teamsToDisplay = teams;
  const effectiveSelectedId = selectedTeamId || teams[0]?.id || null;
  let t1;
  if ($[0] !== effectiveSelectedId) {
    t1 = effectiveSelectedId ? new Set([effectiveSelectedId] as string[]) : new Set();
    $[0] = effectiveSelectedId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedKeys = t1;
  let t2;
  if ($[2] !== effectiveSelectedId || $[3] !== teams) {
    let t3;
    if ($[5] !== effectiveSelectedId) {
      t3 = team => team.id === effectiveSelectedId;
      $[5] = effectiveSelectedId;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = teams.find(t3);
    $[2] = effectiveSelectedId;
    $[3] = teams;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const selectedTeam = t2;
  const t3 = `team-select-${effectiveSelectedId}`;
  let t4;
  if ($[7] !== t) {
    t4 = t("team");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = hasSingleTeam || isLoading || isUpdating;
  let t6;
  if ($[9] !== isLoading || $[10] !== t) {
    t6 = isLoading ? t("loading") : t("select_team");
    $[9] = isLoading;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("team_selector");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      base: "border-primary-300!",
      trigger: "text-zinc-300! border-blue-650! border-1! rounded-lg",
      value: "text-white!",
      label: "text-black! font-mono uppercase text-blue-400! text-xs -mt-1"
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== selectedTeam) {
    t9 = () => {
      if (!selectedTeam) {
        return null;
      }
      return <span className="block overflow-hidden text-ellipsis whitespace-pre">{selectedTeam.name}</span>;
    };
    $[15] = selectedTeam;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== effectiveSelectedId || $[18] !== onSelectionChange) {
    t10 = keys => {
      const selectedKey = Array.from(keys)[0] as string;
      if (selectedKey && selectedKey !== effectiveSelectedId) {
        onSelectionChange(selectedKey);
      }
    };
    $[17] = effectiveSelectedId;
    $[18] = onSelectionChange;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== teamsToDisplay) {
    t11 = teamsToDisplay.map(_temp);
    $[20] = teamsToDisplay;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== selectedKeys || $[23] !== t10 || $[24] !== t11 || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7 || $[30] !== t9) {
    t12 = <Select key={t3} label={t4} variant="bordered" size="sm" selectedKeys={selectedKeys} disallowEmptySelection={true} isDisabled={t5} placeholder={t6} aria-label={t7} classNames={t8} renderValue={t9} onSelectionChange={t10}>{t11}</Select>;
    $[22] = selectedKeys;
    $[23] = t10;
    $[24] = t11;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};
function _temp(team_0) {
  return <SelectItem key={team_0.id} textValue={team_0.name}><span className="whitespace-pre-wrap">{team_0.name}</span></SelectItem>;
}